var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary text-center m4u_text--text"},[_c('span',[_vm._v("©")]),_vm._v("2021 Memories For Us ")])}]

export { render, staticRenderFns }